#import "../../../../setup/sources/graphql/fragments/source-fragment.graphql"

query GetLeadChannels($id: ID!) {
    lead(id: $id) {
        id
        channels {
            totalCount
            sources {
                ...SourceFragment
            }
            edges {
                node {
                    value
                    title
                }
                sources {
                    ...SourceFragment
                }
            }
        }
    }
}
